<template>
  <Transition :name="transition">
    <div
      v-show="isActive"
      tabindex="0"
      class="rr-rating-vld-overlay is-active"
      :class="{ 'is-full-page': isFullPage }"
      :aria-busy="isActive"
      aria-label="Loading"
      :style="{ zIndex: zIndexValue }"
    >
      <div
        class="rr-rating-vld-background"
        :style="{ background: backgroundColor, opacity: opacity }"
        @click.prevent="cancel"
      ></div>
      <div class="rr-rating-vld-icon">
        <slot name="before"></slot>
        <slot name="default">
          <component
            :is="loaderdata"
            :color="color"
            :width="widthBar"
            :height="heightBar"
          ></component>
        </slot>
        <slot name="after"></slot>
      </div>
    </div>
  </Transition>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import { removeElement } from './helpers.js';
import trapFocusMixin from './Plugins/trapFocusMixin.js';
import Loaders from '../loaders/index.js';

export default {
  name: 'rfp-common-loading',
  components: Loaders,
  mixins: [trapFocusMixin],
  props: {
    active: Boolean,
    programmatic: Boolean,
    container: {
      type: Boolean,
      default: false,
    },
    isFullPage: {
      type: Boolean,
      default: true,
    },
    transition: {
      type: String,
      default: 'fade',
    },
    canCancel: Boolean,
    onCancel: {
      type: Function,
    },
    color: String,
    backgroundColor: String,
    opacity: Number,
    width: Number,
    height: Number,
    zIndex: Number,
    loader: {
      type: String,
      default: 'spinner',
    },
  },
  data() {
    return {
      isActive: this.active,
      loaderdata: this.loader,
      zIndexValue: this.zIndex,
      widthBar: this.width,
      heightBar: this.height,
    };
  },
  watch: {
    active(value) {
      this.isActive = value;
    },
  },
  beforeMount() {
    /* istanbul ignore next */
    if (this.programmatic) {
      if (this.container) {
        this.container.appendChild(this.$el);
      } else {
        document.body.appendChild(this.$el);
      }
    }
  },
  mounted() {
    /* istanbul ignore next */
    if (this.programmatic) {
      this.isActive = true;
    }

    document.addEventListener('keyup', this.keyPress);
  },
  created() {
    /* istanbul ignore next */
    eventBus.on('rfp-common-loading-enable', (value) => {
      this.isActive = value;
    });
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.keyPress);
  },
  methods: {
    cancel() {
      /* istanbul ignore next */
      if (!this.canCancel || !this.isActive) return;
      /* istanbul ignore next */
      this.hide();
      /* istanbul ignore next */
      this.onCancel.apply(null, arguments);
    },
    hide() {
      this.$emit('hide');
      this.$emit('update:active', false);
      /* istanbul ignore next */
      if (this.programmatic) {
        this.isActive = false;
        setTimeout(() => {
          this.$destroy();
          removeElement(this.$el);
        }, 150);
      }
    },
    keyPress(event) {
      /* istanbul ignore next */
      if (event.keyCode === 27) this.cancel();
    },
  },
};
</script>
